/**
 * Designer Inspiration Assistant
 * Wizard-basierter Text-Helfer für den Blumentopf-Designer
 */

(function() {
  'use strict';

  // ========================================
  // SPRUCH-DATENBANK
  // ========================================
  const CATEGORIES = [
    { id: 'love', emoji: '💕', label: 'Liebe &\nVerbundenheit' },
    { id: 'family', emoji: '👨‍👩‍👧', label: 'Familie' },
    { id: 'celebrate', emoji: '🎉', label: 'Feiern &\nWünsche' },
    { id: 'thanks', emoji: '🙏', label: 'Danke &\nAbschied' },
    { id: 'newstart', emoji: '🌱', label: 'Neuanfang' },
    { id: 'pet', emoji: '🐾', label: 'Tierfreund' },
    { id: 'humor', emoji: '😄', label: 'Humor &\nSprüche' },
    { id: 'random', emoji: '🎲', label: 'Zufällig\nmit Humor' }
  ];

  // 30 witzige Pflanzensprüche für den Zufalls-Button
  const RANDOM_PHRASES = [
    { line1: 'Ich rede mit', line2: 'meinen Pflanzen', line3: 'Sie hören zu', line4: '(glaube ich)' },
    { line1: 'Pflanzen sterben', line2: 'nicht bei mir', line3: 'Sie gehen in', line4: 'den Urlaub' },
    { line1: 'Grüner Daumen?', line2: 'Eher grüner', line3: 'Versuch', line4: 'Nr. 47' },
    { line1: 'Meine Pflanze', line2: 'und ich:', line3: 'Wahre Liebe', line4: '(einseitig)' },
    { line1: 'Hier wohnt', line2: 'ein Optimist', line3: 'mit Pflanzen', line4: 'Drückt die Daumen!' },
    { line1: 'Photosynthese?', line2: 'Klingt nach', line3: 'einem Plan!', line4: 'Hoffentlich!' },
    { line1: 'Pflanzen sind', line2: 'wie Kinder', line3: 'Nur leiser', line4: '(meistens)' },
    { line1: 'Mein Garten:', line2: '90% Hoffnung', line3: '10% Überleben', line4: 'Daumen drücken!' },
    { line1: 'Ich gieße', line2: 'nach Gefühl', line3: '(Meistens Panik)', line4: 'Es hilft!' },
    { line1: 'Diese Pflanze', line2: 'hat mehr', line3: 'Geduld als', line4: 'mein Chef' },
    { line1: 'Wasser, Sonne,', line2: 'Liebe und', line3: 'viel Glück', line4: 'Meine Formel' },
    { line1: 'Pflanzenflüsterer', line2: 'in Ausbildung', line3: 'Bitte Geduld', line4: 'haben!' },
    { line1: 'Hier kämpft', line2: 'eine Pflanze', line3: 'ums Überleben', line4: 'Respekt!' },
    { line1: 'Meine Pflanze', line2: 'ist stärker', line3: 'als mein', line4: 'Kaffee' },
    { line1: 'Botanik-Genie?', line2: 'Nein.', line3: 'Aber motiviert!', line4: 'Das zählt!' },
    { line1: 'Grün ist', line2: 'die Hoffnung', line3: 'Braun war', line4: 'die letzte...' },
    { line1: 'Pflanzen-Mama', line2: 'ohne Plan', line3: 'aber mit', line4: 'viel Herz' },
    { line1: 'Wenn sie', line2: 'reden könnte', line3: 'würde sie', line4: 'um Hilfe rufen' },
    { line1: 'Mein Motto:', line2: 'Gießen und', line3: 'hoffen!', line4: 'Bisher klappts!' },
    { line1: 'Ich habe', line2: 'einen Plan:', line3: 'Die Pflanze', line4: 'nicht!' },
    { line1: 'Wir wachsen', line2: 'gemeinsam', line3: '(sie schneller)', line4: 'Aber okay!' },
    { line1: 'Naturtalent?', line2: 'Nicht wirklich.', line3: 'Aber fleißig!', line4: 'Das zählt!' },
    { line1: 'Meine Pflanzen', line2: 'sind Helden', line3: 'Sie überleben', line4: 'MICH!' },
    { line1: 'Hier lebt', line2: 'eine Pflanze', line3: 'gegen alle', line4: 'Erwartungen' },
    { line1: 'Viel Wasser,', line2: 'wenig Ahnung', line3: 'Großer Wille!', line4: 'Los gehts!' },
    { line1: 'Pflanzen-Dad', line2: 'im Einsatz', line3: 'Erfolgsquote:', line4: '...offen' },
    { line1: 'Diese Pflanze', line2: 'glaubt an mich', line3: '(hoffe ich)', line4: 'Wir schaffen das!' },
    { line1: 'Unkraut vergeht', line2: 'nicht, sagt man', line3: 'Hoffentlich gilt', line4: 'das auch hier!' },
    { line1: 'Mein grünes', line2: 'Wunder:', line3: 'Immer noch', line4: 'am Leben!' },
    { line1: 'Zusammen alt', line2: 'werden?', line3: 'Challenge', line4: 'accepted!' }
  ];

  const PHRASE_DATABASE = {
    love: {
      sets: [
        {
          line1: 'Glück ist,',
          continuations: [
            { line2: 'wenn man Menschen hat,', line3: 'die das Leben', line4: 'schöner machen' },
            { line2: 'solche Menschen', line3: 'wie dich', line4: 'zu haben' },
            { line2: 'nicht allein', line3: 'sondern gemeinsam', line4: '[Name] & [Name]' },
            { line2: 'wenn jemand', line3: 'an dich denkt', line4: 'In Liebe, [Name]' },
            { line2: 'das hier -', line3: 'du und ich', line4: 'Für immer' }
          ]
        },
        {
          line1: 'Besondere Menschen',
          continuations: [
            { line2: 'sind oft die,', line3: 'die gar nicht wissen', line4: 'wie wundervoll sie sind' },
            { line2: 'verdienen', line3: 'besondere Geschenke', line4: 'Für dich!' },
            { line2: 'wie du', line3: 'machen die Welt', line4: 'ein Stück besser' },
            { line2: 'erkennt man daran,', line3: 'dass sie immer da sind', line4: 'Danke, [Name]!' },
            { line2: 'bleiben', line3: 'für immer', line4: 'im Herzen' }
          ]
        },
        {
          line1: 'Gemeinsam wachsen',
          continuations: [
            { line2: 'wie diese Pflanze', line3: 'jeden Tag', line4: 'ein bisschen mehr' },
            { line2: 'durch Höhen', line3: 'und Tiefen', line4: '[Name] & [Name]' },
            { line2: 'ist schöner', line3: 'als allein', line4: 'Wir zwei!' },
            { line2: 'alt werden', line3: 'zusammen lachen', line4: 'Für immer' },
            { line2: 'Seite an Seite', line3: 'heute und morgen', line4: 'In Liebe' }
          ]
        },
        {
          line1: 'Wir beide',
          continuations: [
            { line2: 'gegen', line3: 'den Rest', line4: 'der Welt' },
            { line2: 'sind das', line3: 'perfekte Chaos', line4: '[Name] & [Name]' },
            { line2: 'und ein', line3: 'Glas Wein', line4: 'Prost!' },
            { line2: 'für immer', line3: 'und ewig', line4: 'Versprochen' },
            { line2: 'unzertrennlich', line3: 'unaufhaltbar', line4: 'unschlagbar' }
          ]
        },
        {
          line1: 'Du bist',
          continuations: [
            { line2: 'mein Zuhause', line3: 'wo immer du bist', line4: 'Für immer' },
            { line2: 'mein Anker', line3: 'in stürmischen Zeiten', line4: 'In Liebe' },
            { line2: 'das Beste', line3: 'was mir passiert ist', line4: '[Name]' },
            { line2: 'mein Lieblingsmensch', line3: 'heute und immer', line4: 'Dein/e [Name]' },
            { line2: 'mein größtes Glück', line3: 'jeden Tag aufs Neue', line4: 'Für immer' }
          ]
        }
      ]
    },
    family: {
      sets: [
        {
          line1: 'Beste Mama',
          continuations: [
            { line2: 'der Welt!', line3: 'Danke für', line4: 'alles!' },
            { line2: 'ever!', line3: 'In Liebe,', line4: '[Name]' },
            { line2: 'wir lieben dich!', line3: 'Deine Kinder', line4: 'Für immer' },
            { line2: 'du bist', line3: 'die Beste!', line4: 'Für immer' },
            { line2: 'Danke, dass du', line3: 'immer für uns', line4: 'da bist!' }
          ]
        },
        {
          line1: 'Bester Papa',
          continuations: [
            { line2: 'der Welt!', line3: 'Danke für', line4: 'alles!' },
            { line2: 'ever!', line3: 'In Liebe,', line4: '[Name]' },
            { line2: 'du bist', line3: 'mein Held!', line4: 'Für immer' },
            { line2: 'Danke für', line3: 'deine Geduld', line4: '(die brauchst du!)' },
            { line2: 'wir lieben dich!', line3: 'Deine Kinder', line4: 'Für immer' }
          ]
        },
        {
          line1: 'Liebste Oma',
          continuations: [
            { line2: 'bei dir ist es', line3: 'am schönsten!', line4: 'Deine Enkel' },
            { line2: 'du bist', line3: 'die Beste!', line4: 'In Liebe' },
            { line2: 'Danke für', line3: 'die Liebe und', line4: 'den Kuchen!' },
            { line2: 'wir haben dich', line3: 'sooo lieb!', line4: 'Deine Enkel' },
            { line2: 'du bist', line3: 'unser Schatz!', line4: 'In Liebe' }
          ]
        },
        {
          line1: 'Liebster Opa',
          continuations: [
            { line2: 'du bist', line3: 'der Beste!', line4: 'Deine Enkel' },
            { line2: 'Danke für', line3: 'die Geschichten', line4: 'und die Zeit!' },
            { line2: 'bei dir ist es', line3: 'am coolsten!', line4: 'In Liebe' },
            { line2: 'wir haben dich', line3: 'sooo lieb!', line4: 'Deine Enkel' },
            { line2: 'du bist', line3: 'unser Held!', line4: 'Für immer' }
          ]
        },
        {
          line1: 'Für meine Familie',
          continuations: [
            { line2: 'ihr seid', line3: 'mein größtes Glück!', line4: 'In Liebe' },
            { line2: 'Danke, dass ihr', line3: 'immer für mich', line4: 'da seid!' },
            { line2: 'zusammen sind wir', line3: 'unschlagbar!', line4: 'Familie [Name]' },
            { line2: 'ihr seid', line3: 'das Beste!', line4: 'Für immer' },
            { line2: 'mit euch ist', line3: 'alles schöner!', line4: 'Danke!' }
          ]
        },
        {
          line1: 'Geschwister',
          continuations: [
            { line2: 'für immer', line3: 'beste Freunde!', line4: '[Name] & [Name]' },
            { line2: 'nervig aber', line3: 'unverzichtbar!', line4: 'Für immer!' },
            { line2: 'zusammen durch', line3: 'dick und dünn!', line4: 'Für immer' },
            { line2: 'Streiten erlaubt,', line3: 'Liebe garantiert!', line4: 'Immer!' },
            { line2: 'Partner in Crime', line3: 'seit Tag 1!', line4: '[Name] & [Name]' }
          ]
        },
        {
          line1: 'Beste Schwiegermama',
          continuations: [
            { line2: 'die man sich', line3: 'wünschen kann!', line4: 'Danke für alles!' },
            { line2: 'der Welt!', line3: 'Danke, dass du', line4: 'mich aufgenommen hast!' },
            { line2: 'du bist', line3: 'ein Geschenk!', line4: 'In Liebe' },
            { line2: 'Danke für', line3: 'deine Herzlichkeit!', line4: 'Von [Name]' },
            { line2: 'wir haben dich', line3: 'so lieb!', line4: 'Deine Schwiegerkinder' }
          ]
        },
        {
          line1: 'Bester Schwiegerpapa',
          continuations: [
            { line2: 'den man sich', line3: 'wünschen kann!', line4: 'Danke für alles!' },
            { line2: 'der Welt!', line3: 'Danke, dass du', line4: 'mich aufgenommen hast!' },
            { line2: 'du bist', line3: 'ein Geschenk!', line4: 'In Liebe' },
            { line2: 'Danke für', line3: 'deine Unterstützung!', line4: 'Von [Name]' },
            { line2: 'wir haben dich', line3: 'so lieb!', line4: 'Deine Schwiegerkinder' }
          ]
        }
      ]
    },
    celebrate: {
      sets: [
        {
          line1: 'Zum [__]. Geburtstag',
          continuations: [
            { line2: 'wünschen wir dir', line3: 'Gesundheit und Glück', line4: 'Deine [Familie]' },
            { line2: 'die besten Wünsche', line3: 'und Zufriedenheit', line4: '[Datum]' },
            { line2: 'alles Liebe', line3: 'und Gute', line4: 'Feier schön!' },
            { line2: 'mögen alle Träume', line3: 'in Erfüllung gehen', line4: 'Von [Name]' },
            { line2: 'viel Freude', line3: 'im neuen Lebensjahr', line4: 'Lass es krachen!' }
          ]
        },
        {
          line1: 'Endlich [__]!',
          continuations: [
            { line2: 'Und immer noch', line3: 'kein bisschen leise', line4: 'Weiter so!' },
            { line2: 'Jung geblieben,', line3: 'nur die Hülle altert', line4: 'Weiter so!' },
            { line2: 'Nicht älter -', line3: 'nur länger jung!', line4: 'Prost!' },
            { line2: 'Älter, weiser', line3: 'und immer noch', line4: 'fabelhaft!' },
            { line2: 'Die besten Jahre', line3: 'kommen erst noch', line4: 'Glaub mir!' }
          ]
        },
        {
          line1: '[__] Jahre',
          continuations: [
            { line2: 'und kein bisschen', line3: 'müde!', line4: 'Happy Birthday!' },
            { line2: 'voller Leben,', line3: 'Liebe und Lachen', line4: 'Auf die nächsten!' },
            { line2: 'jung, wild', line3: 'und wunderbar', line4: 'Deine [Familie]' },
            { line2: 'Erfahrung', line3: 'Weisheit, Charme', line4: 'Alles Gute!' },
            { line2: 'sind erst', line3: 'der Anfang!', line4: 'Feier schön!' }
          ]
        },
        {
          line1: 'Happy Birthday',
          continuations: [
            { line2: 'liebe/r [Name]!', line3: 'Feier schön', line4: 'und hab Spaß!' },
            { line2: 'du Held!', line3: 'Alles Gute', line4: 'zum Geburtstag!' },
            { line2: 'an dich!', line3: 'Mögest du strahlen', line4: 'an deinem Tag!' },
            { line2: 'heute ist', line3: 'dein großer Tag!', line4: 'Lass es krachen!' },
            { line2: 'feiern wir', line3: 'dich und dein', line4: 'neues Lebensjahr!' }
          ]
        },
        {
          line1: 'Alles Gute',
          continuations: [
            { line2: 'zum Geburtstag', line3: 'liebe/r [Name]!', line4: 'Deine [Familie]' },
            { line2: 'und viel Glück', line3: 'für dein neues Jahr', line4: 'Feier schön!' },
            { line2: 'und Gesundheit', line3: 'für die Zukunft!', line4: '[Name]' },
            { line2: 'zum Ehrentag!', line3: 'Du verdienst', line4: 'das Beste!' },
            { line2: 'für dich!', line3: 'Bleib wie du bist!', line4: 'In Liebe' }
          ]
        }
      ]
    },
    thanks: {
      sets: [
        {
          line1: 'Danke, dass du',
          continuations: [
            { line2: 'immer für mich', line3: 'da bist', line4: '[Name]' },
            { line2: 'mir geholfen hast', line3: 'zu wachsen', line4: 'In Dankbarkeit' },
            { line2: 'an meiner Seite', line3: 'warst', line4: 'Von Herzen' },
            { line2: 'mich unterstützt', line3: 'hast', line4: 'Dein Team' },
            { line2: 'so bist', line3: 'wie du bist', line4: '[Name]' }
          ]
        },
        {
          line1: 'Danke für',
          continuations: [
            { line2: 'alles, was du', line3: 'für mich getan hast', line4: 'Von Herzen' },
            { line2: 'die gemeinsame Zeit', line3: 'und die schönen Momente', line4: 'Dein Team' },
            { line2: 'den ganzen', line3: 'Wahnsinn!', line4: 'Wir vermissen dich!' },
            { line2: 'deine Geduld', line3: 'und Unterstützung', line4: '[Name]' },
            { line2: 'alles!', line3: 'Du bist großartig!', line4: 'In Liebe' }
          ]
        },
        {
          line1: 'Endlich Rente!',
          continuations: [
            { line2: 'Genieß jeden Tag', line3: 'in vollen Zügen', line4: 'Dein Team' },
            { line2: 'Ab jetzt nur noch', line3: 'Garten und Grillen', line4: "Mach's gut!" },
            { line2: 'Du hast es', line3: 'dir verdient!', line4: 'Viel Spaß!' },
            { line2: 'Zeit für', line3: 'die schönen Dinge', line4: 'Genieß es!' },
            { line2: 'Füße hoch', line3: 'und entspannen!', line4: 'Deine Kollegen' }
          ]
        },
        {
          line1: 'Tschüss und',
          continuations: [
            { line2: 'viel Glück', line3: 'im Ruhestand!', line4: 'Wir vermissen dich' },
            { line2: 'danke für', line3: 'alles!', line4: 'Alles Gute!' },
            { line2: 'auf Wiedersehen', line3: 'irgendwann!', line4: 'Dein Team' },
            { line2: 'viel Erfolg', line3: 'auf deinem Weg!', line4: "Mach's gut!" },
            { line2: 'bleib so', line3: 'wie du bist!', line4: 'Wir denken an dich' }
          ]
        },
        {
          line1: 'Mit Dankbarkeit',
          continuations: [
            { line2: 'blicke ich zurück', line3: 'auf unsere Zeit', line4: 'Danke für alles!' },
            { line2: 'sage ich', line3: 'Auf Wiedersehen!', line4: 'Dein Team' },
            { line2: 'und Respekt', line3: 'für deine Arbeit!', line4: 'Alles Gute!' },
            { line2: 'für jeden Tag', line3: 'den wir hatten', line4: 'Von Herzen' },
            { line2: 'und warmen Wünschen', line3: 'für die Zukunft', line4: "Mach's gut!" }
          ]
        }
      ]
    },
    newstart: {
      sets: [
        {
          line1: 'Willkommen',
          continuations: [
            { line2: 'kleines Wunder', line3: '[Babyname]', line4: '[Geburtsdatum]' },
            { line2: 'auf der Welt', line3: '[Babyname]', line4: '[Gewicht] g, [Größe] cm' },
            { line2: 'in unserem Leben', line3: '[Babyname]', line4: 'Deine Familie' },
            { line2: 'du Sonnenschein', line3: '[Babyname]', line4: '[Datum]' },
            { line2: 'kleiner Schatz', line3: '[Babyname]', line4: 'Wir lieben dich' }
          ]
        },
        {
          line1: 'Hallo Welt!',
          continuations: [
            { line2: 'Ich bin', line3: '[Babyname]', line4: '[Geburtsdatum]' },
            { line2: 'Hier bin ich!', line3: '[Babyname]', line4: '[Datum]' },
            { line2: 'Endlich da!', line3: '[Babyname]', line4: '[Gewicht] g' },
            { line2: 'Ab jetzt', line3: 'mischt [Babyname]', line4: 'die Welt auf!' },
            { line2: 'Ich bin', line3: 'endlich hier!', line4: '[Babyname]' }
          ]
        },
        {
          line1: 'Home Sweet Home',
          continuations: [
            { line2: 'Herzlich Willkommen', line3: 'im neuen Zuhause', line4: '[Name/Datum]' },
            { line2: 'Hier wohnt', line3: 'das Glück', line4: '[Familie]' },
            { line2: 'Endlich', line3: 'angekommen!', line4: '[Name]' },
            { line2: 'Wo das Herz', line3: 'zuhause ist', line4: '[Familie]' },
            { line2: 'Neues Heim,', line3: 'neues Glück!', line4: '[Datum]' }
          ]
        },
        {
          line1: 'Endlich!',
          continuations: [
            { line2: 'Ein eigenes', line3: 'Chaos!', line4: 'Viel Glück!' },
            { line2: 'Schlüssel in', line3: 'der Hand!', line4: 'Willkommen zuhause!' },
            { line2: 'Mann und Frau', line3: '[Name] & [Name]', line4: '[Hochzeitsdatum]' },
            { line2: 'Zusammen', line3: 'für immer', line4: '[Datum]' },
            { line2: 'Der große Tag!', line3: '[Name] & [Name]', line4: '[Datum]' }
          ]
        },
        {
          line1: 'Ja, ich will!',
          continuations: [
            { line2: '[Name] & [Name]', line3: 'für immer', line4: '[Hochzeitsdatum]' },
            { line2: 'Für immer', line3: 'zusammen', line4: '[Datum]' },
            { line2: 'Zwei Herzen,', line3: 'ein Weg', line4: '[Datum]' },
            { line2: 'Gemeinsam', line3: 'ins Glück', line4: '[Name] & [Name]' },
            { line2: 'Bis dass der Tod', line3: 'uns scheidet', line4: '[Datum]' }
          ]
        }
      ]
    },
    pet: {
      sets: [
        {
          line1: 'In liebevoller',
          continuations: [
            { line2: 'Erinnerung an', line3: '[Tiername]', line4: '[Zeitraum]' },
            { line2: 'Erinnerung', line3: '[Tiername]', line4: 'Für immer' },
            { line2: 'Erinnerung an', line3: 'meinen Freund', line4: '[Tiername]' },
            { line2: 'Erinnerung an', line3: 'unseren treuen', line4: '[Tiername]' },
            { line2: 'Erinnerung', line3: 'für immer', line4: '[Tiername]' }
          ]
        },
        {
          line1: 'Für immer',
          continuations: [
            { line2: 'im Herzen', line3: '[Tiername]', line4: 'Für immer' },
            { line2: 'unvergessen', line3: '[Tiername]', line4: '[Zeitraum]' },
            { line2: 'mein bester', line3: 'Freund', line4: '[Tiername]' },
            { line2: 'geliebt', line3: '[Tiername]', line4: 'Bis wir uns wiedersehen' },
            { line2: 'in Erinnerung', line3: '[Tiername]', line4: 'Du fehlst uns' }
          ]
        },
        {
          line1: 'Hier wacht',
          continuations: [
            { line2: 'über den Garten', line3: '[Tiername]', line4: 'Für immer' },
            { line2: 'mein Engel', line3: '[Tiername]', line4: 'In Liebe' },
            { line2: 'der Chef', line3: '[Tiername]', line4: 'Wuff!' },
            { line2: 'unser Liebling', line3: '[Tiername]', line4: 'In Liebe' },
            { line2: 'über uns', line3: '[Tiername]', line4: 'Für immer im Herzen' }
          ]
        },
        {
          line1: 'Chef im Haus:',
          continuations: [
            { line2: '[Tiername]', line3: 'Alle anderen:', line4: 'Personal!' },
            { line2: '[Tiername]', line3: 'Menschen nur', line4: 'geduldet!' },
            { line2: '[Tiername]', line3: 'Hier regiere', line4: 'ich!' },
            { line2: '[Tiername]', line3: 'Widerspruch', line4: 'zwecklos!' },
            { line2: '[Tiername]', line3: 'Der Boss', line4: 'bin ich!' }
          ]
        },
        {
          line1: 'Mein treuer Freund',
          continuations: [
            { line2: '[Tiername]', line3: 'Für immer in', line4: 'meinem Herzen' },
            { line2: 'auf vier Pfoten', line3: '[Tiername]', line4: 'Unvergessen' },
            { line2: '[Tiername]', line3: 'Du fehlst mir', line4: 'jeden Tag' },
            { line2: 'und Begleiter', line3: '[Tiername]', line4: 'Ruhe in Frieden' },
            { line2: '[Tiername]', line3: 'Danke für', line4: 'die schöne Zeit' }
          ]
        }
      ]
    },
    humor: {
      sets: [
        {
          line1: 'Ich gieße',
          continuations: [
            { line2: 'wenn ich', line3: 'dran denke', line4: 'Drückt die Daumen!' },
            { line2: 'manchmal', line3: 'sogar richtig!', line4: 'Juhu!' },
            { line2: 'nach Gefühl', line3: '(meistens)', line4: 'Bisher lebt sie!' },
            { line2: 'wenn die', line3: 'Pflanze bittet', line4: 'Klappt bisher!' },
            { line2: 'ab und zu', line3: 'vielleicht...', line4: 'Wer weiß?' }
          ]
        },
        {
          line1: 'Diese Pflanze',
          continuations: [
            { line2: 'überlebt', line3: 'trotz mir', line4: 'Sie ist stark!' },
            { line2: 'hat einen', line3: 'Überlebensinstinkt', line4: 'Bisher...' },
            { line2: 'ist stärker', line3: 'als ich dachte', line4: 'Respekt!' },
            { line2: 'kämpft tapfer', line3: 'ums Überleben', line4: 'Du schaffst das!' },
            { line2: 'ist mein', line3: 'ganzer Stolz', line4: '(noch am Leben!)' }
          ]
        },
        {
          line1: 'Wenn ich sterbe,',
          continuations: [
            { line2: 'gießt bitte', line3: 'meine Pflanzen', line4: 'Danke!' },
            { line2: 'kümmert euch', line3: 'um sie!', line4: 'Bitte!' },
            { line2: 'erbt jemand', line3: 'diese Pflanze', line4: 'Viel Glück!' },
            { line2: 'braucht sie', line3: 'ein neues Zuhause', line4: 'Seid nett!' },
            { line2: 'lebt sie', line3: 'hoffentlich weiter', line4: 'Drückt die Daumen!' }
          ]
        },
        {
          line1: 'Hier wohnt',
          continuations: [
            { line2: 'jemand, der mit', line3: 'Pflanzen redet', line4: 'Und sie antworten!' },
            { line2: 'ein hoffnungsloser', line3: 'Pflanzenliebhaber', line4: '(ohne Talent)' },
            { line2: 'eine Pflanze', line3: 'und ihr Mensch', line4: 'Rate wer Chef ist!' },
            { line2: 'der/die', line3: 'Pflanzenflüsterer/in', line4: '(in Ausbildung)' },
            { line2: 'jemand mit', line3: 'grünem Daumen', line4: '...na ja, fast' }
          ]
        },
        {
          line1: 'Pflanzen-Mama',
          continuations: [
            { line2: 'im Training', line3: 'Es wird', line4: '...irgendwann' },
            { line2: 'mit gutem', line3: 'Willen', line4: '(das zählt!)' },
            { line2: 'Status:', line3: 'Pflanze lebt noch!', line4: 'Hurra!' },
            { line2: 'tut ihr', line3: 'Bestes', line4: 'Versprochen!' },
            { line2: 'seit', line3: '[__] Tagen erfolgreich!', line4: 'Neuer Rekord!' }
          ]
        },
        {
          line1: 'Stolze Besitzerin',
          continuations: [
            { line2: 'einer Pflanze', line3: '(noch)', line4: 'Daumen drücken!' },
            { line2: 'von [__] Pflanzen', line3: '([__] davon leben)', line4: 'Fortschritt!' },
            { line2: 'einer sehr', line3: 'geduldigen Pflanze', line4: 'Danke dir!' },
            { line2: 'einer Pflanze', line3: 'die mich erzieht', line4: 'Und wie!' },
            { line2: 'eines grünen', line3: 'Wunders', line4: 'Gegen alle Odds!' }
          ]
        }
      ]
    }
  };

  // ========================================
  // STATE
  // ========================================
  let currentStep = 'category';
  let selectedCategory = null;
  let selectedLine1 = null;
  let selectedLine1Index = null;
  let selectedContinuation = null;

  // ========================================
  // DOM ELEMENTS
  // ========================================
  const modal = document.getElementById('inspiration-modal');
  const openBtn = document.getElementById('open-inspiration');
  const closeBtn = document.getElementById('inspiration-close');
  const backBtn = document.getElementById('inspiration-back');
  const applyBtn = document.getElementById('apply-inspiration');
  const categoryGrid = document.getElementById('category-grid');
  const line1Options = document.getElementById('line1-options');
  const continuationOptions = document.getElementById('continuation-options');
  const selectedLine1Text = document.getElementById('selected-line1-text');

  // ========================================
  // FUNCTIONS
  // ========================================

  function openModal() {
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    resetWizard();
    renderCategories();
  }

  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  function resetWizard() {
    currentStep = 'category';
    selectedCategory = null;
    selectedLine1 = null;
    selectedLine1Index = null;
    selectedContinuation = null;
    updateStepVisibility();
    updateBackButton();
    applyBtn.disabled = true;
  }

  function updateStepVisibility() {
    document.querySelectorAll('.wizard-step').forEach(step => {
      step.classList.remove('active');
    });
    document.getElementById('step-' + currentStep).classList.add('active');
  }

  function updateBackButton() {
    if (currentStep === 'category') {
      backBtn.classList.remove('visible');
    } else {
      backBtn.classList.add('visible');
    }
  }

  function goBack() {
    if (currentStep === 'line1') {
      currentStep = 'category';
      selectedCategory = null;
    } else if (currentStep === 'continuation') {
      currentStep = 'line1';
      selectedContinuation = null;
      applyBtn.disabled = true;
    }
    updateStepVisibility();
    updateBackButton();
  }

  function renderCategories() {
    categoryGrid.innerHTML = '';
    CATEGORIES.forEach(cat => {
      const card = document.createElement('div');
      card.className = 'category-card';
      card.innerHTML = `
        <span class="category-emoji">${cat.emoji}</span>
        <span class="category-label">${cat.label.replace('\n', '<br>')}</span>
      `;
      card.addEventListener('click', () => selectCategory(cat.id));
      categoryGrid.appendChild(card);
    });
  }

  function selectCategory(categoryId) {
    selectedCategory = categoryId;

    if (categoryId === 'random') {
      // Zufälligen Spruch wählen und direkt anwenden
      const randomIndex = Math.floor(Math.random() * RANDOM_PHRASES.length);
      const phrase = RANDOM_PHRASES[randomIndex];

      document.getElementById('designer-line1').value = phrase.line1;
      document.getElementById('designer-line2').value = phrase.line2;
      document.getElementById('designer-line3').value = phrase.line3;
      document.getElementById('designer-line4').value = phrase.line4;

      // Events auslösen für Preview-Update
      ['designer-line1', 'designer-line2', 'designer-line3', 'designer-line4'].forEach(id => {
        document.getElementById(id).dispatchEvent(new Event('input', { bubbles: true }));
      });

      closeModal();
      return;
    }

    currentStep = 'line1';
    updateStepVisibility();
    updateBackButton();
    renderLine1Options();
  }

  function renderLine1Options() {
    const categoryData = PHRASE_DATABASE[selectedCategory];
    if (!categoryData) return;

    const category = CATEGORIES.find(c => c.id === selectedCategory);
    document.getElementById('step-line1-title').textContent = category.emoji + ' ' + category.label.replace('\n', ' ');

    line1Options.innerHTML = '';
    categoryData.sets.forEach((set, index) => {
      const option = document.createElement('div');
      option.className = 'line1-option';
      option.innerHTML = `
        <div class="line1-radio"></div>
        <span class="line1-text">${set.line1}</span>
      `;
      option.addEventListener('click', () => selectLine1(set.line1, index));
      line1Options.appendChild(option);
    });

  }

  function selectLine1(line1Text, setIndex) {
    selectedLine1 = line1Text;
    selectedLine1Index = setIndex;

    // Update visual selection
    document.querySelectorAll('.line1-option').forEach((opt, idx) => {
      opt.classList.toggle('selected', idx === setIndex);
    });

    currentStep = 'continuation';
    updateStepVisibility();
    updateBackButton();
    renderContinuationOptions();
  }

  function renderContinuationOptions() {
    selectedLine1Text.textContent = selectedLine1;

    const categoryData = PHRASE_DATABASE[selectedCategory];
    const set = categoryData.sets[selectedLine1Index];

    continuationOptions.innerHTML = '';
    set.continuations.forEach((cont, index) => {
      const option = document.createElement('div');
      option.className = 'continuation-option';
      option.innerHTML = `
        <div class="continuation-lines">
          <span class="continuation-line">${cont.line2}</span>
          <span class="continuation-line">${cont.line3}</span>
          <span class="continuation-line">${cont.line4}</span>
        </div>
      `;
      option.addEventListener('click', () => selectContinuation(cont, index, option));
      continuationOptions.appendChild(option);
    });
  }

  function selectContinuation(continuation, index, element) {
    selectedContinuation = continuation;

    // Update visual selection
    document.querySelectorAll('.continuation-option').forEach(opt => {
      opt.classList.remove('selected');
    });
    element.classList.add('selected');

    applyBtn.disabled = false;
  }

  function applyInspiration() {
    if (!selectedLine1 || !selectedContinuation) return;

    // Fill in the text fields
    document.getElementById('designer-line1').value = selectedLine1;
    document.getElementById('designer-line2').value = selectedContinuation.line2;
    document.getElementById('designer-line3').value = selectedContinuation.line3;
    document.getElementById('designer-line4').value = selectedContinuation.line4;

    // Trigger input events to update hidden fields
    ['designer-line1', 'designer-line2', 'designer-line3', 'designer-line4'].forEach(id => {
      const input = document.getElementById(id);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    closeModal();

    // Focus on first field with placeholder for easy editing
    const firstInput = document.getElementById('designer-line1');
    if (firstInput.value.includes('[')) {
      firstInput.focus();
      firstInput.select();
    }
  }

  // ========================================
  // EVENT LISTENERS
  // ========================================

  if (openBtn) {
    openBtn.addEventListener('click', openModal);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  if (backBtn) {
    backBtn.addEventListener('click', goBack);
  }

  if (applyBtn) {
    applyBtn.addEventListener('click', applyInspiration);
  }

  // Close on outside click
  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        closeModal();
      }
    });
  }

  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal && modal.style.display === 'flex') {
      closeModal();
    }
  });

})();
